angular
	.module 'App.Module.Strategy', []
	.factory 'StrategyFactory', ['CredentialsManager', 'ConfigurationService', 'UserInformation', (CredentialsManager, ConfigurationService, UserInformation) ->

		class StrategyFactory
			constructor: ->
				@UserInformation = UserInformation
				@CredentialsManager = CredentialsManager
				@ConfigurationService = ConfigurationService

		return new StrategyFactory
	]
